import { APP_ASSETS } from '../../environments/environment';

// images
const imagePath = `${APP_ASSETS}/images`;
export const BMA_LOGO = `${imagePath}/bma_logo.png`;
export const LINE_LOGO = `${imagePath}/line_logo.png`;
export const TWITTER_LOGO = `${imagePath}/twitter_logo.png`;
export const FACEBOOK_LOGO = `${imagePath}/facebook_logo.png`;
export const LINE_LOGO_BLACK = `${imagePath}/ic-line-black.png`;
export const TWITTER_LOGO_BLACK = `${imagePath}/ic-twitter-black.png`;
export const FACEBOOK_LOGO_BLACK = `${imagePath}/ic-facebook-black.png`;
export const HEADER_OLD_IMAGE = `${imagePath}/header_old.png`;
export const HEADER_IMAGE = `${imagePath}/bg.png`;
export const NO_DATA_IMAGE = `${imagePath}/no_data.png`;
export const NO_IMAGE = `${imagePath}/no_image.png`;
export const BASEMAP_STREET_IMAGE = `${imagePath}/basemap_street.png`;
export const BASEMAP_IMAGERY_IMAGE = `${imagePath}/basemap_imagery.png`;
export const BASEMAP_TOPO_IMAGE = `${imagePath}/basemap_topo.png`;
export const BASEMAP_DARK_GRAY_IMAGE = `${imagePath}/basemap_dark_gray.png`;
export const BASEMAP_OSM = `${imagePath}/basemap_osm.png`;
export const AUTH_IMAGE = `${imagePath}/auth_bg_citypark.png`;
export const NO_REQUEST = `${imagePath}/no_request.png`;
export const COVER_IMG = `${imagePath}/cover.png`;

// icons
const iconSvgPath = `${APP_ASSETS}/icons/svg`;
export const DASH_SVG_ICON = `${iconSvgPath}/dash.svg`;
export const BELL_SVG_ICON = `${iconSvgPath}/bell.svg`;
export const EDIT_SVG_ICON = `${iconSvgPath}/edit.svg`;
export const DELETE_SVG_ICON = `${iconSvgPath}/delete.svg`;
export const MAP_SVG_ICON = `${iconSvgPath}/map.svg`;
export const LAYER_SVG_ICON = `${iconSvgPath}/layer.svg`;
export const MEASUREMENT_SVG_ICON = `${iconSvgPath}/ruler.svg`;
export const FULL_SCREEN_SVG_ICON = `${iconSvgPath}/full_screen.svg`;
export const CURRENT_LOCATION_SVG_ICON = `${iconSvgPath}/current_location.svg`;
export const MINUS_LOGO = `${iconSvgPath}/fi_file-minus.svg`;
export const MAIL_LOGO = `${iconSvgPath}/fi_mail.svg`;
export const CALL_LOGO = `${iconSvgPath}/fi_phone-call.svg`;
export const TOC_LAND_SVG_ICON = `${iconSvgPath}/toc_land.svg`;
export const TOC_BILLBOARD_SVG_ICON = `${iconSvgPath}/toc_billboard.svg`;
export const TOC_HOUSE_SVG_ICON = `${iconSvgPath}/toc_house.svg`;
export const TOC_CONDO_SVG_ICON = `${iconSvgPath}/toc_condo.svg`;
export const TOC_PROVINCE_SVG_ICON = `${iconSvgPath}/toc_province.svg`;
export const TOC_DISTRICT_SVG_ICON = `${iconSvgPath}/toc_district.svg`;
export const TOC_SUB_DISTRICT_SVG_ICON = `${iconSvgPath}/toc_subDistrict.svg`;
export const TOC_SURVEYED_SVG_ICON = `${iconSvgPath}/toc_surveyed.svg`;
export const TOC_UNSURVEYED_SVG_ICON = `${iconSvgPath}/toc_unsurveyed.svg`;
export const TOC_EXEMPT_SVG_ICON = `${iconSvgPath}/toc_exempt.svg`;
export const PDS_5_ICON = `${iconSvgPath}/pds5.svg`;
export const PDS_10_ICON = `${iconSvgPath}/pds10.svg`;
export const PDS_32_ICON = `${iconSvgPath}/pds32.svg`;
export const MENU_HOME_SVG_ICON = `${iconSvgPath}/menu_home.svg`;
export const MENU_REQUEST_SVG_ICON = `${iconSvgPath}/menu_request.svg`;
export const MENU_ESTATE_SVG_ICON = `${iconSvgPath}/menu_estate.svg`;
/** export const MENU_DOWNLOAD_SVG_ICON = `${iconSvgPath}/menu_download.svg`; */
export const MENU_DOWNLOAD_SVG_ICON = `${iconSvgPath}/menu_payment.svg`;
export const MENU_VERIFY_SVG_ICON = `${iconSvgPath}/menu_verify.svg`;
export const MENU_PAYMENT_SVG_ICON = `${iconSvgPath}/menu_payment.svg`;
export const MENU_FAQ_SVG_ICON = `${iconSvgPath}/ic-faq.svg`;
export const REG_NATURAL_PERSON = `${iconSvgPath}/reg_natural_person.svg`;
export const REG_LEGAL_ENTITY = `${iconSvgPath}/reg_legal_entity.svg`;
export const RESULT_PASS = `${iconSvgPath}/result_pass.svg`;
export const DOCUMENT_ICON = `${iconSvgPath}/document.svg`;
export const ESTATE_ICON = `${iconSvgPath}/estate.svg`;
export const ADD_IMAGE = `${iconSvgPath}/add_image.svg`;
export const BIN_ICON = `${iconSvgPath}/bin.svg`;
export const MASTER_KEY_ICON = `${iconSvgPath}/master_key.svg`;
export const DOWNLOAD_ICON = `${iconSvgPath}/download.svg`;
export const DOWNLOAD_WHITE_ICON = `${iconSvgPath}/download_white.svg`;
export const UPLOAD_ICON = `${iconSvgPath}/upload.svg`;
export const UPLOAD_WHITE_ICON = `${iconSvgPath}/upload_white.svg`;
export const USER_ICON = `${iconSvgPath}/user.svg`;
export const SETTING_ICON = `${iconSvgPath}/setting.svg`;
export const LOGOUT_ICON = `${iconSvgPath}/logout.svg`;
export const IMAGE_ICON = `${iconSvgPath}/image_icon.svg`;

// document
const documentPath = `${APP_ASSETS}`;
export const PDF_SAMPLE = `${documentPath}/sample.pdf`;
export const PDF_SAMPLE_2 = `${documentPath}/sampl2.pdf`;
